
import React from 'react';

const Solution: React.FC = () => {
  const features = [
    {
      icon: (
        <svg className="w-8 h-8 text-pink-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      title: 'TOEFL 공식 자료 활용',
      desc: '가장 공신력 있는 TOEFL 공식 자료를 통해 대학 수준의 아카데믹 영어를 체계적으로 학습합니다.'
    },
    {
      icon: (
        <svg className="w-8 h-8 text-pink-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      ),
      title: '4대 영역 무제한 밀착 첨삭',
      desc: '말하기 녹음본과 쓰기 에세이를 매 수업마다 1:1로 밀착 피드백하여 나쁜 습관을 즉시 교정합니다.'
    },
    {
      icon: (
        <svg className="w-8 h-8 text-pink-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      title: '개인별 맞춤형 목표 관리',
      desc: '개인의 현재 수준에 맞춘 고강도 커리큘럼을 제공합니다. 30회 안에 목표 달성을 보장합니다.'
    }
  ];

  return (
    <div className="py-24 relative overflow-hidden bg-[#FAF7F2]">
       {/* Background style text */}
       <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[15vw] font-black text-[#F2ECE4] select-none z-0">
          LEARNING
       </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-pink-300 font-bold tracking-widest text-sm uppercase mb-4">Our Methodology</h2>
          <h3 className="text-3xl md:text-5xl font-extrabold text-slate-800">30회 만에 실력을 바꾸는 <br className="md:hidden"/> 3단계 핵심 솔루션</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((f, idx) => (
            <div key={idx} className="bg-white p-10 rounded-3xl border border-[#F2ECE4] shadow-lg hover:shadow-pink-100/30 hover:translate-y-[-5px] transition-all duration-300 group">
              <div className="w-16 h-16 bg-pink-50 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-pink-100 transition-colors">
                {f.icon}
              </div>
              <h4 className="text-xl font-bold text-slate-800 mb-4">{f.title}</h4>
              <p className="text-slate-500 leading-relaxed text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Solution;
